import { LEARN_LANGUAGES } from './languages';
import appConfig from '../utils/appConfig';

const learnLanguageWithoutQMS = () =>
  Object.keys(LEARN_LANGUAGES).filter((lang) => lang !== 'QMS');

const LANGUAGE_SELECTION_ARRANGEMENTS = {
  default: learnLanguageWithoutQMS(),
  pl: [
    'ENG',
    'DEU'
  ],
  en_GB: [
    'SPA',
    'FRA',
    'ITA',
    'DEU',
    'POR',
    'SWE',
    'TUR',
    'NLD',
    'POL',
    'DAN',
    'NOR',
    'IND',
    'RUS'
  ],
  en: [
    'SPA',
    'FRA',
    'ITA',
    'DEU',
    'POR',
    'QMS',
    'SWE',
    'TUR',
    'NLD',
    'POL',
    'DAN',
    'NOR',
    'IND',
    'RUS'
  ]
};

const getLanguageSelectionArrangement = (locale) =>
  LANGUAGE_SELECTION_ARRANGEMENTS[locale] || LANGUAGE_SELECTION_ARRANGEMENTS.default;

const isLearnLanguageValid = (learnLanguage, locale) =>
  learnLanguage.alpha2 !== locale;

const mapLearnLangKeyToLearnLangData = (learnLanguageKey) =>
  Object.assign({
    learnLanguage: learnLanguageKey,
    learnLanguageTranslation: appConfig.getLanguageTranslation(learnLanguageKey)
  }, LEARN_LANGUAGES[learnLanguageKey]);

export default (locale) =>
  getLanguageSelectionArrangement(locale)
    .map(mapLearnLangKeyToLearnLangData)
    .filter((learnLanguage) => isLearnLanguageValid(learnLanguage, locale));
